import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#003366",
        secondary: "#999999",
        accent: "#DFE5EC",
        background: "#FFFFFF"
      }
    }
  }
});
